import { Injectable } from '@angular/core';
import { FieldType, Formatters, Editors, EditorValidator, EditorArgs, AngularUtilService } from 'angular-slickgrid';
import { RxMethods } from 'src/app/common/services/rxjs.service';
import { Validators } from '@angular/forms';
import { CustomNumberOnlyEditor } from 'src/app/common/components/cue-table/custom-editors/number-only.editor';
import { gridconfig } from '../../../app-enum.enum';
import { customNumberOnlyValidator } from '../../../common/components/cue-table/validator/validator.component';
import { CustomAngularComponentEditor } from 'src/app/common/components/cue-table/custom-editors/custom-angular-component-editor';
import { AutoCompleteComponent } from 'src/app/common/components/auto-complete/auto-complete.component';
import { CustomAngularComponentFilter } from 'src/app/common/components/cue-table/custom-editors/custom-angular-component-filter';
import { GridDateFormatter } from 'src/app/common/components/cue-table/custom-formatters/custom-date-formatter';
import { DateTimePickerComponent } from 'src/app/common/components/date-time-picker/date-time-picker.component';
@Injectable()
export class ReworkConfigService {
    selectedReworkItems: any[];
    selectedItemToSplit: object;
    selectedPlan: string;
    planDatasource: object = {};
    // gridSource = this.rxMethods.createSubjectService();
    modalFormConfig = {
        'showSideBar': false,
        'showReset': false
    };
    filterConfigs = {
        'showSideBar': false,
        'showReset': false
    };
    selectedRows: object = {
        planDetails: [],
        pickupSeq: []
    };
    isRouteChanged = false;
    isRefresh = false;
    isSplitAndAddExisiting = false;
    locationCombo = [];
    selectedRoute: any;
    isPickModified = false;

    constructor(private rxMethods: RxMethods,
        private angularUtilService: AngularUtilService) { }


    setPlanDatasource(data: any) {
        this.planDatasource = data;
    }

    getPlanDatasource() {
        return this.planDatasource;
    }

    // setGridSource(gridArray: any) {
    //     // this.setPlanDatasource(gridArray);

    //     this.gridSource.next(gridArray);
    // }

    getReworkConfigTableColumnConfigs(currentScope) {
        return [{
            id: 'id',
            name: 'Seq No',
            field: '',
            sortable: true,
            columnGroup: 'Plan Details',
            formatter: function (row) { return (row + 1); },
            minWidth: 40
        },
        // {
        //     id: 'PLAN_LINE',
        //     name: 'Plan line',
        //     field: 'PLAN_LINE',
        //     sortable: true,
        //     type: FieldType.string,
        //     columnGroup: 'Plan Details',
        //     minWidth: 120
        // },
        {
            id: 'REQUEST_LINE',
            name: 'Request No & Line',
            field: 'REQUEST_LINE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            // formatter: function (row, cell, value, columnDef, dataContext) {
            //     return '<a class="cursor-pointer"' +
            //         'onclick="' + currentScope.navigateToCreateScreen + '">' + value + '</a>';
            // },
            minWidth: 100
        },
        {
            id: 'PAYLOAD_TYPE',
            name: 'Payload Type',
            field: 'PAYLOAD_TYPE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 120
        },
        {
            id: 'DESCRIPTION',
            name: 'Name/Item Description',
            field: 'DESCRIPTION',
            sortable: true,
            columnGroup: 'Plan Details',
            type: FieldType.date,
            minWidth: 250
        },
        {
            id: 'QTYUOM',
            name: 'Quantity & UOM',
            field: 'QTYUOM',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 80
        },
        {
            id: 'ORIGIN',
            name: 'Origin',
            field: 'ORIGIN',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 275
        },
        {
            id: 'DESTINATION',
            name: 'Destination',
            field: 'DESTINATION',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 275
        },
        {
            id: 'PICKDT_TM',
            name: 'Req Pick Date-Time',
            field: 'PICKDT_TM',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150
        },
        {
            id: 'DROPDT_TM',
            name: 'Req Drop Date-Time',
            field: 'DROPDT_TM',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150,
        },
        {
            id: 'EXPIRYDATE',
            name: 'Expiry Date',
            field: 'EXPIRYDATE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150,
        },
        {
            id: 'EXPIRYTIME',
            name: 'Expiry Time',
            field: 'EXPIRYTIME',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150,
        },
        {
            id: 'WEIGHT',
            name: 'Weight(In Tons)',
            field: 'WEIGHT',
            type: FieldType.integer,
            formatter: Formatters.decimal,
            editor: { model: CustomNumberOnlyEditor },
            maxLength: 7,
            columnGroup: 'Plan Details',
            minWidth: 150,
        },
        // {
        //     id: '',
        //     name: 'Possible Pick Seq',
        //     field: '',
        //     sortable: true,
        //     type: FieldType.string,
        //     columnGroup: 'Plan Details',
        //     minWidth: 80,
        // },
        // {
        //     id: '',
        //     name: 'Possible Pick Date',
        //     field: '',
        //     sortable: true,
        //     type: FieldType.boolean,

        //     columnGroup: 'Plan Details',
        //     minWidth: 80,
        // },
        // {
        //     id: '',
        //     name: 'Possible Drop Date',
        //     field: '',
        //     sortable: true,
        //     type: FieldType.boolean,
        //     columnGroup: 'Plan Details',
        //     minWidth: 80,
        // },
        {
            id: 'POURINTERCART',
            name: 'Pour or Intercart',
            field: 'POURINTERCART',
            sortable: true,
            type: FieldType.boolean,
            columnGroup: 'Plan Details',
            minWidth: 120,
        },
        {
            id: 'CONTACT_NO',
            name: 'Contact No.',
            field: 'CONTACT_NO',
            sortable: true,
            type: FieldType.string,
            minWidth: 100
        }
        ];
    }

    getPickSeqTableConfigs() {
        return {
            gridId: 'pickseqGrid',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            selectedItems: [],
            exportFileName: 'Split List',
            canAddRowManually: false,
            canDeleteRowManually: false,
            canCopyRows: false,
            canCopyMat: true,
            showColumnFilter: false,
            emptyObject: {},
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            editable: true,
            showFilter: false,
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: true
            },
            autoResize: {
                maxHeight: gridconfig.gridHeightForPlanDetailTab,
            },
            createPreHeaderPanel: true,
            showPreHeaderPanel: true,
            enablePagination: false,
            enableGrouping: false,
            autoEdit: true,
            alwaysShowVerticalScroll: false,
            forceFitColumns: false,
            asyncEditorLoading: false,
            autoCommitEdit: true,
            enableAsyncPostRender: true,
            asyncPostRenderDelay: 0,
            selectedRowKeyName: 'id',
            params: { angularUtilService: this.angularUtilService }
        };
    }

    getReworkCancelTemplate() {
        return [{
            'id': 'strRejectComment',
            'labelName': 'Reason',
            'type': 'search',
            'minlength': 1,
            'placeholder': 'Select Reason',
            'isVisible': true,
            'model': '',
            'changeApi': '',
            'displayField': 'value',
            'valueField': 'id',
            'datasource': [],
            'validations': [Validators.required],
            'position': 0,
            'class': 'col-md-12'
        }];
    }

    getReworkConfigTableConfigs() {
        return {
            gridId: 'reworkConfigsTable',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            selectionMode: 'multiple', // TODO: Need to configure
            selectedItems: [],
            exportFileName: 'Plan Rework List',
            dateFormat: 'DD/MM/YYYY',
            canAddRowManually: false,
            canDeleteRowManually: false,
            autoCommitEdit: true,
            canCopyRows: false,
            showColumnFilter: false,
            emptyObject: {},
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            enableRowSelection: false,
            editable: true,
            selectedRowKeyName: 'id',
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: false
            },
            autoResize: {
                maxHeight: gridconfig.gridHeightForPlanDetailTab,
            },
            createPreHeaderPanel: true,
            showPreHeaderPanel: true,
            enablePagination: false,
            enableGrouping: false,
            forceFitColumns: false,
            autoEdit: true
        };
    }

    setSelectedReworkItems(selectedItems) {
        this.selectedReworkItems = selectedItems[0];
    }

    getSelectedReworkItems() {
        return this.selectedReworkItems;
    }

    getReworkFilterForm() {
        return [
            {
                'id': 'unionFilter',
                'labelName': 'Union Filter',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-2'
            },
            {
                'id': 'EXPIRYDATE',
                'labelName': 'Expiring Lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-2'
            },
            {
                'id': 'chkRetain',
                'labelName': 'TAT<SLA lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-2'
            },
            {
                'id': 'PAYLOAD_TYPE',
                'labelName': 'Pax lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-2'
            },
            {
                'id': 'POURINTERCART',
                'labelName': 'Pour lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-3'
            },
            {
                'id': 'POURINTERCART',
                'labelName': 'Intercart lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-3'
            },
            {
                'id': 'chkRetain',
                'labelName': 'Other (general) lines',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-3'
            }
        ]
    }

    getReworkPlanForm(scope) {
        return [
            {
                'id': 'strPlanNumber',
                'labelName': 'Plan No',
                'type': 'input',
                'inputType': 'text',
                'isVisible': true,
                'isReadOnly': false,
                'changeApi': '',
                'validations': [],
                'position': 0,
                'class': 'col-md-3',
                'scope': scope,
                'allowOnlyEnter': true,
                'onEnter': scope.updateFormValues
            },
            {
                'id': 'chkContSch',
                'labelName': 'Fixed Vehicle Allocation',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': true,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-3'
            },
            {
                'id': 'strLogisticsOfficeRO',
                'labelName': 'Logistics office',
                'type': 'input',
                'inputType': 'text',
                'isVisible': true,
                'isReadOnly': true,
                'changeApi': '',
                'validations': [],
                'position': 0,
                'class': 'col-md-3'
            },
            {
                'id': 'strStatus',
                'labelName': 'Plan Status',
                'type': 'input',
                'inputType': 'text',
                'isVisible': true,
                'isReadOnly': true,
                'changeApi': '',
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },
            {
                'id': 'strLda',
                'labelName': 'Long Distance Allowance',
                'type': 'checkbox',
                'isVisible': true,
                'isDisabled': false,
                'changeApi': '',
                'validations': [],
                'isBinary': true,
                'position': 11,
                'class': 'col-md-3'
            },
            {
                'id': 'strComments',
                'labelName': 'Comments',
                'type': 'input',
                'inputType': 'text',
                'isVisible': true,
                'isReadOnly': true,
                'changeApi': '',
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },
            // {
            //     'id': 'strLogisticsOffice',
            //     'labelName': 'Transfer to Logistics office',
            //     'type': 'search',
            //     'placeholder': 'Select Office',
            //     'minlength': 1,
            //     'isVisible': true,
            //     'model': '',
            //     'changeApi': '',
            //     'displayField': 'value',
            //     'valueField': 'id',
            //     'datasource': [],
            //     'validations': [Validators.required],
            //     'position': 3,
            //     'class': 'col-md-3'
            // },

        ]
    };

    getReworkFilterConfigs() {
        return {
            'showSideBar': false,
            'showReset': false
        }
    }

    // Split Modal Configs
    getSplitConfigTableColumnConfigs(currentScope) {
        return [{
            id: 'id',
            name: 'Seq No',
            field: '',
            type: FieldType.string,
            formatter: function (row) { return (row + 1); },
            columnGroup: 'Plan Details',
            minWidth: 25
        },
        {
            id: 'PLAN_NO',
            name: 'Plan No',
            field: 'PLAN_NO',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 80
        },
        {
            id: 'PLAN_LINE',
            name: 'Plan Line',
            field: 'PLAN_LINE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 60
        },
        {
            id: 'PAYLOAD_TYPE',
            name: 'Payload type',
            field: 'PAYLOAD_TYPE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150
        },
        {
            id: 'DESCRIPTION',
            name: 'Item Description',
            field: 'DESCRIPTION',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 250
        },
        {
            id: 'QTY',
            name: 'Qty',
            field: 'QTY',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 40
        },
        {
            id: 'WEIGHT',
            name: 'Weight(In Tons)',
            field: 'WEIGHT',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 80
        },
        {
            id: 'UOM',
            name: 'UOM',
            field: 'UOM',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 100
        },
        {
            id: 'SPLIT_QTY',
            name: 'SPLIT QUANTITY',
            field: 'SPLIT_QTY',
            sortable: true,
            type: FieldType.integer,
            columnGroup: 'Plan Details',
            editor: {
                model: CustomNumberOnlyEditor
            },
            regex: /[^0-9]/g,
            validator: customNumberOnlyValidator,
            maxLength: 6,
            minWidth: 150
        },
        {
            id: 'MULTI_SPLIT',
            name: 'Multiple Split',
            field: 'MULTI_SPLIT',
            sortable: true,
            formatter: Formatters.checkmark,
            type: FieldType.boolean,
            editor: {
                // display checkmark icon when True
                enableRenderHtml: true,
                model: Editors.checkbox,
                collection: [
                    { value: 'Y', label: 'Yes', labelPrefix: `<i class="fa fa-check"></i> ` },
                    { value: 'N', label: 'No' }
                ]
            },
            columnGroup: 'Plan Details',
            minWidth: 100
        }
        ];
    }

    splitQuantityValidator(value: any, args: EditorArgs) {
    }

    getSplitTableConfigs() {
        return {
            gridId: 'splitModalTable',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            selectionMode: 'multiple', // TODO: Need to configure
            selectedItems: [],
            exportFileName: 'Split List',
            dateFormat: 'DD/MM/YYYY',
            canAddRowManually: false,
            canDeleteRowManually: false,
            canCopyRows: false,
            showColumnFilter: false,
            showFilter: false,
            emptyObject: {},
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            editable: true,
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: true
            },
            createPreHeaderPanel: true,
            showPreHeaderPanel: true,
            enablePagination: false,
            enableGrouping: false,
            autoEdit: true,
            alwaysShowVerticalScroll: true,
            forceFitColumns: true,
            isautoResizeColumn: false,
            autoCommitEdit: true
        };
    }

    //pick-up seq
    getPickupSeqColumnConfigs(scope) {
        return [
            {
                id: 'id',
                name: 'Seq No',
                field: '',
                sortable: true,
                columnGroup: 'Pick Sequence',
                formatter: function (row) { return (row + 1); },
                minWidth: 25
            },
            {
                id: 'LOC_CODE',
                name: 'Location',
                field: 'LOC_CODE',
                sortable: true,
                comboId: 'strOrigin',
                type: FieldType.object,
                filterable: true,
                formatter: Formatters.complexObject,
                dataKey: 'id',
                labelKey: 'value',
                value: '*',
                editor: {
                    model: CustomAngularComponentEditor,
                    // customStructure: { label: 'value', value: 'id' },
                    collection: [],
                    params: {
                        component: AutoCompleteComponent,
                        configs: {
                            'id': 'LOC_CODE',
                            'placeholder': 'Select Location',
                            'comboId': 'strOrigin',
                            'displayField': 'value',
                            'valueField': 'id',
                            'enableVirtualScroll': true,
                            'bufferSize': 25,
                            'datasource': [],
                            'scope': scope,
                            'model': '',
                            'isGrid': true
                        }
                    }
                },
                filter: {
                    model: new CustomAngularComponentFilter(), // create a new instance to make each Filter independent from each other
                    collection: [],
                    params: {
                        component: AutoCompleteComponent,
                    }
                },
                queryFieldFilter: 'LOC_CODE.id',
                queryFieldSorter: 'LOC_CODE.value',
                params: {
                    complexFieldLabel: 'LOC_CODE.value',
                },
                minWidth: 150,
                columnGroup: 'Pick Sequence'
            },
            {
                id: 'IS_PICK',
                name: 'Is Pick',
                field: 'IS_PICK',
                sortable: true,
                formatter: Formatters.checkmark,
                type: FieldType.boolean,
                editor: {
                    // display checkmark icon when True
                    enableRenderHtml: true,
                    model: Editors.checkbox,
                    collection: [
                        { value: 'Y', label: 'Yes', labelPrefix: `<i class="fa fa-check"></i> ` },
                        { value: 'N', label: 'No' }
                    ]
                },
                columnGroup: 'Pick Sequence',
                minWidth: 70
            },
            {
                id: 'POSSIBLEPICKSEQ',
                name: 'Pick Seq',
                field: 'POSSIBLEPICKSEQ',
                sortable: true,
                type: FieldType.integer,
                editor: { model: CustomNumberOnlyEditor },
                maxLength: 4,
                columnGroup: 'Pick Sequence',
                minWidth: 100
            },
            {
                id: 'TIME',
                name: 'Duration',
                field: 'TIME',
                sortable: true,
                type: FieldType.string,
                editor: {
                    model: CustomAngularComponentEditor,
                    params: {
                        component: DateTimePickerComponent,
                        configs: {
                            'id': 'EXPIRY_TIME',
                            'type': 'datePicker',
                            'maxDate': '',
                            'minDate': '',
                            'invalidDates': [],
                            'disabledDays': [],
                            'validations': [],
                            'noOfMonths': 1,
                            'isDisabled': false,
                            'isGrid': true,
                            'model': '',
                            'dateFormat': 'HH:mm',
                            'placeholder': 'HH:MM',
                            'pickerType': 'timer'
                        }
                    }
                },
                columnGroup: 'Pick Sequence',
                minWidth: 110
            },
            {
                id: 'DISTANCE',
                name: 'Distance',
                field: 'DISTANCE',
                sortable: true,
                type: FieldType.string,
                columnGroup: 'Pick Sequence',
                editor: { model: CustomNumberOnlyEditor },
                minWidth: 100
            }];
    }

    getExistingPlanGridColumnConfig() {
        return [{
            id: 'id',
            name: 'Seq No',
            field: 'id',
            type: FieldType.string,
            formatter: function (row) { return (row + 1); },
            minWidth: 40,
            columnGroup: 'Plan Details'
        },
        {
            id: 'REQUEST_LINE',
            name: 'Request No ',
            field: 'REQUEST_LINE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150
        },
        {
            id: 'REF_DOC',
            name: 'Ref Doc No',
            field: 'REF_DOC',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150
        },
        {
            id: 'ORIGIN',
            name: 'Origin',
            field: 'ORIGIN',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 250
        },
        {
            id: 'DESTINATION',
            name: 'Destination',
            field: 'DESTINATION',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 250
        },
        {
            id: 'PAYLOAD_TYPE',
            name: 'Payload Type',
            field: 'PAYLOAD_TYPE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 150
        },
        {
            id: 'PLAN_DATE',
            name: 'Plan date',
            field: 'PLAN_DATE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 130
        },
        {
            id: 'PLAN_MODEL',
            name: 'Plan model',
            field: 'PLAN_MODEL',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 100
        },
        {
            id: 'VEH_MODEL',
            name: 'Vehicle category',
            field: 'VEH_MODEL',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 100
        },
        {
            id: 'ROUTE',
            name: 'Route',
            field: 'ROUTE',
            sortable: true,
            type: FieldType.string,
            columnGroup: 'Plan Details',
            minWidth: 180
        }];
    }

    getExistingPlanGridConfig() {
        return {
            gridId: 'addToExistingModalTable',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            selectedItems: [],
            exportFileName: 'Split List',
            dateFormat: 'DD/MM/YYYY',
            canAddRowManually: false,
            canDeleteRowManually: false,
            canCopyRows: false,
            showColumnFilter: false,
            showFilter: false,
            emptyObject: {},
            recStatus: 'I',
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            autoCommitEdit: true,
            enableRowSelection: false,
            editable: false,
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: false
            },
            createPreHeaderPanel: false,
            alwaysShowVerticalScroll: true,
            showPreHeaderPanel: false,
            enablePagination: false,
            enableGrouping: false,
            autoEdit: true,
            autoResize: {
                maxHeight: gridconfig.gridHeightForAddToExisting,
            },
        };
    }

    getExistingPlanFilterTemplate() {
        return [
            {
                'id': 'strConsPayloadType',
                'labelName': 'Payload Type',
                'type': 'search',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'model': '',
                'changeApi': '',
                'displayField': 'value',
                'valueField': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },
            {
                'id': 'strFromDate',
                'labelName': 'Plan Date',
                'type': 'picker',
                'placeholder': 'DD/MM/YYYY',
                'isVisible': true,
                'pickerType': 'calendar',
                'dateFormat': 'DD/MM/YYYY',
                'maxDate': '',
                'minDate': '',
                'invalidDates': [],
                'disabledDays': [],
                'noOfMonths': 1,
                'validations': [],
                'position': 2,
                'class': 'col-md-3'
            },
            {
                'id': 'strSelVehicleType',
                'labelName': 'Vehicle Category',
                'type': 'search',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'model': '',
                'changeApi': '',
                'displayField': 'value',
                'valueField': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },
            {
                'id': 'strSelRoute',
                'labelName': 'Route',
                'type': 'search',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'model': '',
                'changeApi': '',
                'displayField': 'value',
                'valueField': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },
            {
                'id': 'strConsOrigin',
                'labelName': 'Origin',
                'type': 'multiselect',
                'seperator': ',',
                'optionLabel': 'value',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'model': '',
                'changeApi': '',
                'displayField': 'value',
                'valueField': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-9 multi_value orgin padding-0'
            },
            {
                'id': 'strSelPlanModel',
                'labelName': 'Plan Model',
                'type': 'search',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'model': '',
                'changeApi': '',
                'displayField': 'value',
                'valueField': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-3'
            },

            {
                'id': 'strConsDestination',
                'labelName': 'Destination',
                'type': 'multiselect',
                'placeholder': '',
                'minlength': 1,
                'isVisible': true,
                'seperator': ',',
                'model': '',
                'changeApi': '',
                'optionLabel': 'value',
                'patchValue': '',
                'datasource': [],
                'validations': [],
                'position': 1,
                'class': 'col-md-9 orgin  multi_value padding-0'

            },
            //  {
            //     'id': '',
            //     'labelName': 'QtyUom',
            //     'type': 'input',
            //     'inputType': 'text',
            //     'isVisible': true,
            //     'isDisabled': false,
            //     'changeApi': '',
            //     'validations': [],
            //     'position': 1,
            //     'class': 'col-md-4'
            // },
            {
                'id': 'searchButton',
                'buttonName': 'Search',
                'isVisible': true,
                'onClickEvent': '',
                'onChangeEvent': '',
                'type': 'button'
            }];
    }

    // Plan Details section starts here
    planParameterFormTemplate(scope) {
        return [{
            'id': 'dtPlanDate',
            'labelName': 'Start Date',
            'type': 'picker',
            'isVisible': true,
            'pickerType': 'both',
            'placeholder': 'DD/MM/YYYY HH:MM',
            'dateFormat': 'DD/MM/YYYY HH:mm',
            'showLabel': true,
            'maxDate': '',
            'minDate': '',
            'invalidDates': [],
            'disabledDays': [],
            'noOfMonths': 1,
            'isDisabled': false,
            'validations': [Validators.required],
            'position': 1,
            'labelClass': 'col-md-4',
            'elemClass': 'col-md-8 no-padding',
            'class': 'col-md-3'
        },
        {
            'id': 'dtEndDate',
            'labelName': 'End Date',
            'type': 'picker',
            'isVisible': true,
            'pickerType': 'both',
            'placeholder': 'DD/MM/YYYY HH:MM',
            'dateFormat': 'DD/MM/YYYY HH:mm',
            'showLabel': true,
            'maxDate': '',
            'minDate': '',
            'invalidDates': [],
            'disabledDays': [],
            'noOfMonths': 1,
            'isDisabled': false,
            'validations': [Validators.required],
            'position': 1,
            'labelClass': 'col-md-4',
            'elemClass': 'col-md-8 no-padding',
            'class': 'col-md-3'
        }, {
            'id': 'strReqRetain',
            'labelName': 'Requested retain',
            'type': 'checkbox',
            'isVisible': true,
            'isDisabled': true,
            'changeApi': '',
            'validations': '',
            'isBinary': true,
            'position': 3,
            'class': 'col-md-3'
        }, {
            'id': 'strConfirmRetain',
            'labelName': 'Confirm retain',
            'type': 'checkbox',
            'isVisible': true,
            'isDisabled': false,
            'changeApi': '',
            'validations': '',
            'isBinary': true,
            'position': 4,
            'class': 'col-md-3'
        },
            // {
            //     'id': 'confirmPlanParams',
            //     'controlName': 'Confirm Plan Params',
            //     'isDisabled': false,
            //     'isVisible': true,
            //     'onClick': scope.onConfirmPlanParams,
            //     'scope': scope,
            //     'onChangeEvent': '',
            //     'type': 'buttonEvent'
            // }
        ];
    }

    getAvailableResourcesFormTemplate() {
        return [{
            'id': 'strAddEscort',
            'labelName': 'Add escort?',
            'type': 'checkbox',
            'isVisible': true,
            'isDisabled': false,
            'changeApi': '',
            'validations': [],
            'isBinary': true,
            'position': 11,
            'class': 'col-md-3'
        }, {
            'id': 'strShareCapacity',
            'labelName': 'Share capacity?',
            'type': 'checkbox',
            'isVisible': true,
            'isDisabled': false,
            'changeApi': '',
            'validations': [],
            'isBinary': true,
            'position': 11,
            'class': 'col-md-3'
        }, {
            'id': 'strUtilization',
            'labelName': 'Utilization estimate',
            'type': 'search',
            'placeholder': '',
            'minlength': 1,
            'isVisible': true,
            'model': '',
            'changeApi': '',
            'displayField': 'value',
            'valueField': '',
            'datasource': [],
            'validations': [],
            'position': 1,
            'class': 'col-md-3'
        }, {
            'id': 'strDriverClose',
            'labelName': 'Driver close POD',
            'type': 'checkbox',
            'isVisible': true,
            'isDisabled': false,
            'changeApi': '',
            'validations': [],
            'isBinary': true,
            'position': 11,
            'class': 'col-md-3'
        }]
    }

    getAvailableResourcesGridColumnConfigs(status?) {
        return [
            {
                id: 'VEHICLE_NO',
                name: 'Vehicle No',
                field: 'VEHICLE_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 90

            },
            {
                id: 'VEHICLE_REG_NO',
                name: 'Vehicle Plate No',
                field: 'VEHICLE_REG_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 90
            },
            {
                id: 'VEHICLE_TYPE',
                name: 'Vehicle type',
                field: 'VEHICLE_TYPE',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'DRIVER_CODE',
                name: 'Select Driver',
                field: 'DRIVER_CODE',
                sortable: true,
                type: FieldType.object,
                minWidth: 220,
                formatter: (row, cell, value, columnDef, dataContext) => {
                    // const driver = value ? value : '';
                    const driver = (value ? (dataContext.DRIVER_CODE + (dataContext.DRIVER_NAME ? (' - ' + dataContext.DRIVER_NAME) : '')) : '');
                    if (status === 'Released') { return driver; }
                    else {
                        return '<label class="cursor-pointer" tooltip="' + driver + '">' + driver + '</label><i id="selectDriver-' + dataContext.VEHICLE_REG_NO + '" class="fa fa-search align-right"></i><i id="selectedDriverRemove-' + dataContext.VEHICLE_REG_NO + '" class="fa fa-times align-right"></i>';
                    }
                }
            },
            {
                id: 'PRIME_MOVER_CODE',
                name: 'Select Prime Mover',
                field: 'PRIME_MOVER_CODE',
                sortable: true,
                type: FieldType.object,
                minWidth: 220,
                formatter: (row, cell, value, columnDef, dataContext) => {
                    if (dataContext.TRAILER === 'Yes') {
                        const primer = (value ? (dataContext.PRIME_MOVER_CODE + (dataContext.PRIME_MOVER_NAME ? (' - ' + dataContext.PRIME_MOVER_NAME) : '')) : '');
                        if (status === 'Released') { return primer; }
                        else {
                            return '<label class="cursor-pointer" tooltip="' + primer + '">' + primer + '</label> <i id="selectPrime-' + dataContext.VEHICLE_REG_NO + '" class="fa fa-search align-right"></i><i id="selectedPrimeRemove-' + dataContext.VEHICLE_REG_NO + '" class="fa fa-times align-right"></i>';
                        }
                    }
                }
            },
            {
                id: 'TRK_CAPACITY',
                name: 'Rated Capacity',
                field: 'TRK_CAPACITY',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'TRK_DESC',
                name: 'Vehicle Description',
                field: 'TRK_DESC',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: '',
                name: 'Utility KMS',
                field: '',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            }
        ];
    }

    getGeneralPlanGridConfigs() {
        return {
            gridId: 'availableResourceTable',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            selectionMode: 'multiple', // TODO: Need to configure
            exportFileName: 'Plan List',
            dateFormat: 'DD/MM/YYYY',
            canAddRowManually: false,
            canDeleteRowManually: false,
            canCopyRows: false,
            showColumnFilter: false,
            showFilter: true,
            emptyObject: {},
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            editable: false,
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: true
            },
            autoResize: {
                maxHeight: 280,
            },
            createPreHeaderPanel: false,
            showPreHeaderPanel: false,
            enablePagination: false,
            enableGrouping: false,
            autoEdit: false,
            enableHeaderMenu: true,
            alwaysShowVerticalScroll: false,
            forceFitColumns: false,
            selectedRowKeyName: 'id',
            isHighlightRow: true,
            highlightConditions: [{
                hightLightKey: 'isExists',
                condition: 'true',
                color: 'bg-color-green'
            }]
        };
    }

    shareOpportunitiesGridColumnConfigs() {
        return [
            {
                id: 'PLAN_NO',
                name: 'Plan No',
                field: 'PLAN_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'VEHICLE_NO',
                name: 'Vehicle No',
                field: 'VEHICLE_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'VEHICLE_TYPE',
                name: 'Vehicle type',
                field: 'VEHICLE_TYPE',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'VEHICLE_SHARE',
                name: 'Vehicle share %',
                field: 'VEHICLE_SHARE',
                sortable: true,
                type: FieldType.string,
                minWidth: 130
            },
            {
                id: 'BASE_PLANT',
                name: 'Base plant',
                field: 'BASE_PLANT',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'ORIGIN',
                name: 'Origin',
                field: 'ORIGIN',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'DESTINATION',
                name: 'Destination',
                field: 'DESTINATION',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'START_TIME',
                name: 'Start time',
                field: 'START_TIME',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'START_STATUS',
                name: 'Start status',
                field: 'START_STATUS',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'JP_NO',
                name: 'JP No',
                field: 'JP_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 150
            },
            {
                id: 'JP_MGR_NM',
                name: 'JM Name',
                field: 'JP_MGR_NM',
                sortable: true,
                type: FieldType.string,
                minWidth: 200
            },
            {
                id: 'JM_NO',
                name: 'JM No',
                field: 'JM_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'ETA',
                name: 'ETA @ Base',
                field: 'ETA',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'ONWARD_ROUTE',
                name: 'Onward route',
                field: 'ONWARD_ROUTE',
                sortable: true,
                type: FieldType.string,
                minWidth: 200
            }
        ];
    }

    consolidatedOppsGridColumnConfigs() {
        return [
            {
                id: 'PLAN_NO',
                name: 'Plan No',
                field: 'PLAN_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'REF_DOC_NO',
                name: 'Ref Doc Number',
                field: 'REF_DOC_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'LINE_NO',
                name: 'Line No',
                field: 'LINE_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'STATUS',
                name: 'Status',
                field: 'STATUS',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'VEH_REG_NO',
                name: 'Vehicle',
                field: 'TRK_CAPACITY',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'TRK_CAPACITY ',
                name: 'Rated Capacity',
                field: 'TRK_CAPACITY ',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'TRK_DESC',
                name: 'Vehicle Description',
                field: 'TRK_DESC',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'PAYLOAD_TYPE',
                name: 'Payload type',
                field: 'PAYLOAD_TYPE',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'DESCRIPTION',
                name: 'Name or desc.',
                field: 'DESCRIPTION',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'QTY',
                name: 'Qty',
                field: 'QTY',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'UOM',
                name: 'UOM',
                field: 'UOM',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'WEIGHT',
                name: 'Weight (In Tons)',
                field: 'WEIGHT',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'VOLUME',
                name: 'Volume (In CBM)',
                field: 'VOLUME',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'PICK_TIME',
                name: 'Pick time',
                field: 'PICK_TIME',
                sortable: true,
                type: FieldType.string,
                // editor: { model: CustomTimerEditor },
                minWidth: 100
            },
            {
                id: 'DROP_TIME',
                name: 'Drop time',
                field: 'DROP_TIME',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: 'ORIGIN',
                name: 'Origin',
                field: 'ORIGIN',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'DESTINATION',
                name: 'Destination',
                field: 'DESTINATION',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            }
        ];
    }

    getSelectionModalGridConfigs() {
        return {
            gridId: 'selectionModalTable',
            idField: 'id',
            containerHeight: '98vh',
            canExportAsExcel: true, // TODO: Need to Configure
            exportFileName: '',
            dateFormat: 'DD/MM/YYYY',
            canAddRowManually: false,
            canDeleteRowManually: false,
            canCopyRows: false,
            showColumnFilter: false,
            showFilter: true,
            emptyObject: {},
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            editable: false,
            rowSelectionOptions: {
                // True (Single Selection), False (Multiple Selections)
                selectActiveRow: false
            },

            createPreHeaderPanel: false,
            showPreHeaderPanel: false,
            enablePagination: false,
            enableGrouping: false,
            autoEdit: false,
            autoCommitEdit: true,
            hideClearAllFiltersCommand: true,
            hideClearAllSortingCommand: true,
            hideToggleFilterCommand: true,
            hideExportCsvCommand: true,
            hideExportTextDelimitedCommand: true,
            hideRefreshDatasetCommand: true,
            enableHeaderMenu: true,
            alwaysShowVerticalScroll: false,
            forceFitColumns: false
        };
    }

    // Vehicle 
    getAvailableDriversGridColumnConfigs() {
        return [
            {
                id: 'DRIVER_NO',
                name: 'Driver ID',
                field: 'DRIVER_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 90
            },
            {
                id: 'DRIVER_NAME',
                name: 'Name',
                field: 'DRIVER_NAME',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'DRIVER_CONTACT_NO',
                name: 'Contact',
                field: 'DRIVER_CONTACT_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 90
            },
            {
                id: '',
                name: 'Default driver',
                field: '',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: '',
                name: 'Status',
                field: '',
                sortable: true,
                type: FieldType.string,
                minWidth: 90
            },
            {
                id: '',
                name: 'Utility HRS',
                field: '',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            },
            {
                id: '',
                name: 'Qualified for',
                field: '',
                sortable: true,
                type: FieldType.object,
                minWidth: 120
            },
            {
                id: 'NATIONALITY_ID',
                name: 'Driver Nationality',
                field: 'NATIONALITY_ID',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'DRIVER_TYPE',
                name: 'Driver Type',
                field: 'DRIVER_TYPE',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            }
        ];
    }

    // Prime Movers 
    getAvailablePrimersGridColumnConfigs() {
        return [
            {
                id: 'PLATE_NO',
                name: 'Plate No',
                field: 'PLATE_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'REG_NO',
                name: 'Reg No',
                field: 'REG_NO',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'DESCRIPTION',
                name: 'Description',
                field: 'DESCRIPTION',
                sortable: true,
                type: FieldType.string,
                minWidth: 180
            },
            {
                id: 'PM_OWNERSHIP',
                name: 'Ownership',
                field: 'PM_OWNERSHIP',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: '',
                name: 'Utility KMS',
                field: '',
                sortable: true,
                type: FieldType.string,
                minWidth: 120
            },
            {
                id: 'CABIN_CAPACITY',
                name: 'Cabin capacity',
                field: 'CABIN_CAPACITY',
                sortable: true,
                type: FieldType.string,
                minWidth: 100
            }
        ];
    }
}

